// AuthContext.js
import React, { createContext, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Flex, Spin } from 'antd';
import { authState } from '../state/reducerAtoms/auth.atom';
import { isLoggedIn, logoutUser } from '../helpers/auth.helper';
import LoginPage from '../pages/auth/login';
import { getProfile } from '../services/api/auth';

const PUBLIC_PATHS = ['/register', '/register/details'];

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(isLoggedIn());
    const [authDetails, setAuthDetails] = useRecoilState(authState);

    const isPublicPath = PUBLIC_PATHS.includes(window.location.pathname);

    const fetchAuthDetails = async () => {
        try {
            getProfile().then((data) => {
                if (!data) {
                    logoutUser();
                } else {
                    setAuthDetails((prv)=> ({...prv, isLoggedIn: true, ...data?.data}))
                }
            }).finally(() => setIsLoading(false));
        } catch (error) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isLoggedIn()) {
            fetchAuthDetails();
        }
    }, [isLoggedIn]);

    if (isPublicPath) {
        return <>{children}</>;
    }

    return (
        <>
            {isLoading ?
                <Flex gap="middle" vertical>
                    <Spin spinning={isLoading} />
                </Flex> :
                (isLoggedIn() ? <AuthContext.Provider value={{ auth: authDetails }}>
                    {children}
                </AuthContext.Provider> :
                    <LoginPage />)
            }
        </>
    );
};

export const useAuth = () => {
    return React.useContext(AuthContext);
};